<template>
  <div class="statistics">
    <b-loading :active="loading" />
    <div class="mb-4 page-title">
      <h1>
        統計報表
        <small class="subtitle">此處可以依日期範圍查詢訂購報表</small>
      </h1>
    </div>
    <div class="statistics__section statistics-table">
      <section class="is-flex is-flex-wrap-wrap statistics-infos">
        <div class="is-align-items-start is-flex is-flex-direction-column mx-7 my-6">
          <label class="has-text-grey mb-2 statistics-infos--title">查詢日期範圍</label>
          <div class="is-flex items-center">
            <div class="mr-4">
              <b-radio
                v-model="dateType"
                class="mr-3"
                name="date_type"
                native-value="start"
              >
                依開放訂購日
              </b-radio>
              <b-radio
                v-model="dateType"
                name="date_type"
                native-value="receive"
              >
                依領取起始日
              </b-radio>
            </div>
            <b-field>
              <b-datepicker
                :date-formatter="dateFormatter"
                :first-day-of-week="1"
                :min-date="isChangingDate ? minDate : null"
                :max-date="maxDate"
                class="statistics-infos__date-picker"
                icon="calendar-alt"
                locale="zh-TW"
                placeholder="請選擇日期範圍"
                range
                v-model="dates"
                @range-end="onEndChanges"
                @range-start="onStartChanges"
              />
            </b-field>
          </div>
        </div>
      </section>
    </div>
    <div class="statistics__section statistics-table">
      <b-tabs v-model="activeTab" class="statistics-tabs" @input="onTabChange">
        <b-tab-item
          value="groupBuyings"
          label="依訂購統計" />
        <b-tab-item
          value="members"
          label="依人員統計" />
      </b-tabs>
      <section class="flex items-center justify-between filter">
        <div class="flex gap-6">
          <b-input
            v-model="filter"
            :disabled="!hasDateRange"
            placeholder="搜尋人員編號、帳號、姓名"
            class="filter__input"
            @keypress.enter.native="onSearch" />
          <w-button
            :disabled="!filter || !hasDateRange"
            size="sm"
            @click="onSearch">
            搜尋
          </w-button>
          <w-button
            color-type="secondary"
            size="sm"
            type="link"
            @click="onReset"
          >
            清除
          </w-button>
          <w-button
            :disabled="!hasDateRange"
            size="sm"
            type="link"
            @click="openedFilter = !openedFilter"
          >
          進階篩選
            <i
              :class="openedFilter ? 'icon-up-chevron' : 'icon-down-chevron'"
              class="ml-2"
            />
          </w-button>
        </div>
        <div class="flex items-center justify-end">
          <w-button
            :disabled="disableExport"
            :loading="isExporting"
            color-type="secondary"
            size="func"
            type="link"
            @click="exportReport"
          >
            <span class="flex items-center">
              <i
                :class="disableExport ? 'text-gray-300' : 'text-secondary-500'"
                class="icon-cloud-download mr-2 text-lg"
              />
              匯出報表
            </span>
          </w-button>
        </div>
      </section>
      <div v-if="openedFilter" class="bg-light-gray-400 flex mx-4 rounded px-4 py-2">
        <div class="flex flex-wrap flex-grow gap-y-4 item-center">
          <div class="flex items-center">
            <label class="flex-shrink-0 mr-4 text-gray-500 text-sm">付款狀態</label>
            <span
              v-for="item in filterTagItems"
              :class="{ active: paymentStatus.includes(item.value) }"
              :key="`selection-filter-${item.value}-${item.type}`"
              :title="item.label"
              class="selection-item"
              @click="onSelectItem(item)"
            >
              {{ item.label }}
            </span>
          </div>
          <div class="border-light-gray-500 border-r mx-6" />
          <div class="flex flex-grow items-baseline">
            <label class="flex-shrink-0 mr-4 text-gray-500 text-sm">部門</label>
            <w-select
              v-model="advancedSearchUnits"
              :options="userUnits"
              class="flex-grow max-w-[400px]"
              multiple
              placeholder="請選擇部門"
              show-checked-icon
              @change="advancedSearchUnitsChange"
            />
          </div>
        </div>
      </div>
      <div class="m-4">
        <div v-if="isFiltered" class="mb-2 text-xs">
          你正在找
          <span class="has-text-link">{{ filter }}</span>
          ，符合條件共 {{ records.length }} 筆結果
        </div>
        <member-list
          :has-date-range="hasDateRange"
          :records="formattedRecords"
          :loading="loading"
          :show-title="!isFiltered"
          @detail="toDetail"
        />
        <div v-if="total && !loading" class="flex gap-4 items-center">
          <b-select v-model="perPage">
            <option
              v-for="option in perPageOptions"
              :value="option.value"
              :key="option.label"
            >
              {{ option.label }}
            </option>
          </b-select>
          <div class="flex-grow">
            <b-pagination
              :total="total"
              v-model="page"
              range-before="3"
              range-after="1"
              nextIcon="right-chevron"
              prevIcon="left-chevron"
              :per-page="perPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberStatistics from './MemberStatistics';

export default MemberStatistics;
</script>

<style lang="scss" scoped>
@import 'MemberStatistics';
</style>
